interface ITranscodingSize {
  width: number;
  height: number;
}

export type TranscodingSize = Partial<Readonly<ITranscodingSize>>;

export type FullTranscodingSize = Readonly<ITranscodingSize>;

// Specify the 1x transcoding sizes. Values should be numeric, representing pixel size.
export const TRANSCODING_LESSON_VIEW_LARGE: TranscodingSize = ({ height: 384 });
export const TRANSCODING_LESSON_VIEW_MEDIUM: TranscodingSize = ({ height: 256 });
export const TRANSCODING_LESSON_VIEW_SMALL: TranscodingSize  = ({ height: 128 });

export const TRANSCODING_LESSON_HEADER: FullTranscodingSize = ({ width: 800, height: 600 });
export const TRANSCODING_LESSON_TEASER: TranscodingSize     = ({ width: 300 });

export const TRANSCODING_THUMBNAIL: FullTranscodingSize       = ({ width: 100, height: 100 });
export const TRANSCODING_THUMBNAIL_SMALL: FullTranscodingSize = ({ width: 60, height: 60 });

export const TRANSCODING_PORTRAIT: TranscodingSize = ({ width: 300 });

export const TRANSCODING_MODAL: FullTranscodingSize = ({ width: 1280, height: 800 });

// Chat images
export const TRANSCODING_CHAT_THUMBNAIL: FullTranscodingSize = ({ width: 300, height: 440 });

export const TRANSCODING_PAGE_WIDE_BG_IMAGE: TranscodingSize = ({ width: 1200 });
